import { AutogenModelZoneRegion, AutogenRowZoneRegion } from "./autogen/AutogenModelZoneRegion";

export class ModelZoneRegion extends AutogenModelZoneRegion<RowZoneRegion> {
	constructor() {
		super(RowZoneRegion);
	}
}

export class RowZoneRegion extends AutogenRowZoneRegion {
}